goog.provide("shadow.js.shim.module$src$svg$type$ad_format$meta_single_video_svg$default");
shadow.js.shim.module$src$svg$type$ad_format$meta_single_video_svg$default = shadow.js.shim.module$src$svg$type$ad_format$meta_single_video_svg.default;
